/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { mediaImageGenerate } from '../../axios/mediaImageGenerate'
import type {
	MediaImageGenerateError,
	MediaImageGeneratePathParams,
	MediaImageGenerateRequest,
	MediaImageGenerateResponse,
} from '../../types/MediaImageGenerate'

export const mediaImageGenerateMutationKey = () => [{ url: '/media/:organisation/images/generate' }] as const

export type MediaImageGenerateMutationKey = ReturnType<typeof mediaImageGenerateMutationKey>

export type MediaImageGenerateVariables = {
	organisation: MediaImageGeneratePathParams['organisation']
	data: MediaImageGenerateRequest
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/MediaImageController.php MediaImageController::generate */
export function useMediaImageGenerate<TContext = unknown>(
	options?: UseMutationOptions<
		MediaImageGenerateResponse,
		AxiosError<MediaImageGenerateError>,
		MediaImageGenerateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: mediaImageGenerateMutationKey(),
		mutationFn: ({ organisation, data }: MediaImageGenerateVariables) =>
			mediaImageGenerate(organisation, data, config).then(res => res.data),
		...options,
	})
}
